import i18n from "multilingual";
import { toast } from "react-toastify";
import { constants } from "redux/constants/redux-constants";
import { store } from "redux/store";
import { recognizerManager } from "screens/patientInfo/classes/RecognizerManager";

export const initializeSpeechService = (dispatch, payload) => {
  const { handleTranscribed, handleTranscribing } = payload;
  const getState = store?.getState;

  dispatch({
    type: constants.RECOGNIZER.START_RECORDING_LOADING,
    payload: true,
  });

  const region = process.env.REACT_APP_SERVICE_REGION;
  const { token, language } = getState().recognizer;

  recognizerManager.initializeSpeechService(token, language, region);
  recognizerManager.startTranscription(
    handleTranscribing,
    handleTranscribed,
    dispatch
  );
};

export const errorMessageReducer = (error) => {
  switch (error?.errorCode) {
    case "subscription.expired":
      toast.error(i18n.t("error_messages.SUBSCRIPTION_EXPIRED"));
      break;
    default:
      toast.error(error?.message || error?.errorMessage);
  }
};
